import React from "react";
import {  MenuItem,ContextMenu } from "react-contextmenu";
import "../../styles/customMenuItem.scss";

export const CustomMenuItem = (menuList) => (
  <ContextMenu id="contextMenu" className="context-menu">
    {menuList.map(({label,onClick})=> (
      <MenuItem onClick={onClick} key={label}>
        <div className="label">     
          {label}
        </div>
      </MenuItem>
))}
  </ContextMenu>
)
   

    

